export default __webpack_public_path__ + "static/media/Emotion.ef560bc9.png";